<template>
    <div class="card-container">
        <common-top-form :model="formModel" :submitService="submitService" :submitData="submitData" @success="onSuccess"
                         :show="false">
            <select-organs v-model="formModel.tatSimpleId" :needAll="false"></select-organs>
            <!--<el-form-item label="公排名称">-->
                <!--<el-input v-model="formModel.platoonName" maxlength="20" placeholder="请输入名称"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="公排状态">-->
                <!--<el-select v-model="formModel.status" placeholder="请选择">-->
                    <!--<el-option-->
                        <!--v-for="item in status"-->
                        <!--:key="item.dictKey"-->
                        <!--:label="item.dictValue"-->
                        <!--:value="item.dictKey">-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="启动日期">-->
                <!--<el-date-picker-->
                    <!--v-model="formModel.time"-->
                    <!--type="date"-->
                    <!--value-format="yyyy-MM-dd"-->
                    <!--placeholder="请选择启动日期">-->
                <!--</el-date-picker>-->
            <!--</el-form-item>-->
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="platoonName" min-width="130" label="名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="blue-text table-text-button" @click="handleNext(scope.row)">{{scope.row.platoonName ? scope.row.platoonName : '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="promotionTime" label="启动日期" min-width="130" :formatter="formatterTableData" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="130" :formatter="formatterTableStatus" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="操作时间" min-width="160" :formatter="formatterTableDate" show-overflow-tooltip></el-table-column>
            <el-table-column prop="modifier" label="操作人" min-width="160" :formatter="formatterTableData"
                             show-overflow-tooltip></el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService"
                     @success="dialogSuccess" @close="dialogClose">
            <el-form-item label="名称" prop="platoonName">
                <el-input v-model="dialogModel.platoonName" maxlength="20" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="启动日期" prop="promotionTime">
                <el-date-picker
                    v-model="dialogModel.promotionTime"
                    :picker-options="pickerOptions"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择启动日期">
                </el-date-picker>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import FormDialog from '../../dialog/FormDialog'
    import SelectOrgans from 'components/business/SelectOrgans'

    import MarketService from 'service/MarketService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "setpublicplatoon",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
            SelectOrgans,
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                },
                dialogModel: {
                    platoonName: '',
                    promotionTime: '',
                },
                status: [{
                    dictKey: '',
                    dictValue:'全部'
                },{
                    dictKey: '0',
                    dictValue:'禁用'
                },{
                    dictKey: '1',
                    dictValue:'启用'
                },{
                    dictKey: '2',
                    dictValue:'待启动'
                },],
                formDialogTitle: '',
                submitService: MarketService.tatPublicPlatoonList,
                tableData: [],
                isPage: false,
                dialogId: '',
                page: {},
                dialogRules: {
                    platoonName: [{
                        required: true,
                        message: '请选择统计路线'
                    }],
                    promotionTime: [{
                        required: true,
                        message: '请选择启动时间'
                    }],
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                }
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                const params = {
                    pId: 0,
                    tatSimpleId: this.formModel.tatSimpleId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return params;
            },
            dialogService() {
                return this.dialogId ? MarketService.tatPublicPlatoonEdit : MarketService.tatPublicPlatoonAdd;
            },
            dialogData() {
                const params = {
                    pId: 0,
                    platoonName: this.dialogModel.platoonName,
                    promotionTime: this.dialogModel.promotionTime,
                    modifier: this.userId
                };
                if (this.dialogId) {
                    params.id = this.dialogId;
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId', 'orgDetail'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;

            this.getList();
        },
        methods: {
            formatterTableStatus(row, column, cellValue, index) {
                let value = '--';
                this.status.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue
                    }
                });
                return value;
            },
            formatterTableDate(row, column, cellValue, index) {
                return row.updateTime ? row.updateTime : row.createTime;
            },
            addInfo(item) {
                this.dialogId = '';
                if (item) {
                    this.dialogId = item.id;
                    this.getDetail(item)
                }
                this.formDialogTitle = this.dialogId ? '添加' : '修改';
                this.dialogType = true;
                this.$refs.formDialog.open();
            },
            handleNext(item){
                this.$router.push({
                    name: 'setpublicplatoon',
                    params:{
                        item: JSON.stringify({...item,'tatSimpleId':this.formModel.tatSimpleId})
                    }
                })
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    }, '信息获取失败'
                )
            },
            getDetail(item) {
                this.dialogModel = JSON.parse(JSON.stringify(item));

            },
            dialogSuccess(data) {
                this.doCheck(data, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.getList();
                    this.$refs.formDialog.closeDialog();
                });
            },
            dialogClose() {
                this.dialogModel = {
                    platoonName: '',
                    promotionTime: '',
                };
            },
            doDelete(id) {
                this.doLoad(MarketService.tatPublicPlatoonDel, {
                    pId: 0,
                    id: id
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            Delete(id) {
                this.showConfirm(`确定删除此公排？`).then(() => {
                    this.doDelete(id)
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>
    .levelList {
        display: flex;
        flex-wrap: wrap;
    }

    .unit {
        margin-left: 10px;
        color: #aaaaaa;
        word-break: keep-all;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/SetPublicPlatoonPage.vue